import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import {
	AccordionContent,
	AccordionItem,
	AccordionRoot,
	AccordionTrigger,
} from "~/components/ui/Accordions/Accordion/Accordion";
import type { FAQsStoryblok, RichTextStoryblok } from "~/generated/sb/blok-types";
import styles from "./FAQsBlok.module.css";

export const FAQsBlok = ({ blok, preview }: BlokProps<FAQsStoryblok>) => {
	const Title = () => (!blok?.title ? null : <h2 className={styles.title}>{blok.title}</h2>);

	return (
		<BlokWrap
			editable={blok}
			className={clsx(styles.root, "faqs-blok")}
			data-layout="blok"
			data-container="small"
		>
			<div>
				<Title />
				<AccordionRoot className={styles.faqs}>
					{blok?.questions.map((q) => (
						<AccordionItem key={q._uid}>
							<AccordionTrigger>{q.question}</AccordionTrigger>
							<AccordionContent className={styles.answer}>
								{q.answer?.map((answer: RichTextStoryblok) => (
									<StoryblokComponent blok={answer} key={answer._uid} preview={preview} />
								))}
							</AccordionContent>
						</AccordionItem>
					))}
				</AccordionRoot>
			</div>
		</BlokWrap>
	);
};
